// extracted by mini-css-extract-plugin
module.exports = {"container":"AllOrders_container__1RQhk","products":"AllOrders_products__1RTEA"};